<template>
  <div class="app-consumption-item">
    <b-row v-if="isFlatrate" class="pb-3">
      <b-col class="custom-progress-bar">
        <slot name="iconPhone"></slot>
        <b-progress max="100" class="consumption-progress">
          <b-progress-bar value="100">
            <div class="consumption-info">
              Allnet Flat
            </div>
          </b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="custom-progress-bar">
        <slot v-if="consumption.type === 'DATA'" name="iconData"></slot>
        <slot v-else name="iconPhone"></slot>
        <b-progress :max="consumption.max" class="consumption-progress">
          <b-progress-bar :value="consumption.left">
            <div class="consumption-info">
              {{ formatNumber(consumption.consumed) }} von {{ formatNumber(consumption.max) }} <Unit :unit="consumption.unit"/> verbraucht
            </div>
          </b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import Unit from './Unit.vue'
import slotProxy from '../../../../mixins/slotProxy'
export default {
  components: { Unit },
  props: {
    consumption: {
      type: Object,
      default: () => {}
    },
    tariffId: {
      type: String,
      default: ''
    },
    consumptionTitle: {
      type: Boolean,
      default: true
    },
    isFlatrate: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    slotProxy()
  ],
  name: 'ConsumptionItemProgress',
  methods: {
    formatNumber (number) {
      if (this.$config?.calendar?.formatter?.numberFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.numberFormatter.format(number)
    }
  }
}
</script>
